<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Content Article</li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Artikel</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Artikel</h4>
          </div>
          <div class="panel-body panel-form">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form class="form-horizontal form-bordered">
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('section_id') >= 0 }">
                <label class="col-md-2 control-label">Pilih Section *</label>
                <div class="col-md-8 col-xs-12">
                  <select class="form-control" v-model="form.section_id">
                    <option :value="item.id" v-for="(item,index) in listSection" v-bind:key="index">{{ item.name }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('name') >= 0 }">
                <label class="col-md-2 control-label">Judul *</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.name"/>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('description') >= 0 }">
                <label class="col-md-2 control-label">Deskripsi</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.description"/>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('link') >= 0 || !is_url_valid, 'has-success': is_url_valid}">
                <label class="col-md-2 control-label">Link</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.link"/>
                  <span class="help-text">must start with <strong>http://</strong> or <strong>https://</strong></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Upload Gambar</label>
                <div class="col-md-8 col-xs-12">
											<div class="row">
												<div class="col-md-4" v-if="form.picture">
													<img class="img-fluid" :src="form.picture" />
												</div>
												<div class="col-md-8">
                          <app-imagecropper v-on:finished="handleChangePicture($event)" v-bind:aspectRatio="0.5"/>
												</div>
											</div>
										</div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('status') >= 0 }">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-8 col-xs-12">
                  <select class="form-control" v-model="form.status">
                    <option value="PUBLISHED">Published</option>
                    <option value="HIDDEN">Hidden</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                 <label class="col-md-2 control-label"></label>
                 <div class="col-md-8 col-xs-12">

                  <button v-if="$route.query.id" type="button" class="btn btn-success btn-md" @click="save()">Simpan Perubahan</button>
                  <button v-else type="button" class="btn btn-success btn-md" @click="save()">Simpan</button>

                 </div>
               </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ContentService from '@/services/content.js'
import URLValidator from '@/services/url_validator.js'
import Spinner from '@/components/plugins/Spinner'
import ImageCropper from '@/components/plugins/ImageCropper'

export default {
  name: 'content-article-form',
  components: {
    'app-spinner': Spinner,
    'app-imagecropper': ImageCropper
  },
  data: function() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      listSection: [],
      form: {
        id: 0,
        name: null,
        description: null,
        link: null,
        picture: null,
        status: null,
        section_id: null
      },
      selectedPicture: null,
      errors: [],
      is_url_valid: false
    }
  },
  mounted: function () {
    this.loadSection()
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
      this.fetchData()
    }
  },
  watch: {
    'form.link': function(val) {
      if (val.length == 0) return
      this.is_url_valid = URLValidator.validate(val)
    }
  },
  methods: {
    fetchData: function () {
			var data = this.$store.state.content.editContent
      var content = JSON.parse(data.content)
      this.form = {
        id: data.id,
        name: content.title,
        description: content.description,
        link: content.link,
        picture: content.image_url,
        status: data.status,
        section_id: data.section.id
      }
		},
    loadSection: function() {
      var context = this
      ContentService.getContentDetailByType('ARTICLE',function (result) {
        if(result.success) context.listSection = result.data
        else alert('pengambilan section list gagal')
      })
    },
    save: function() {
      var context = this

      if (!this.isDeeplink && !this.form.link.includes('http')) {
        var httpLink = 'http://' + this.form.link
        this.form.link = httpLink;
      }

      if(this.validateForm()) {
        context.isLoading = true
        if(this.selectedPicture !== null){
          var strJSON = {
            title: this.form.name,
            description: this.form.description,
            link: this.form.link,
          }
        } else {
          var strJSON = {
            title: this.form.name,
            description: this.form.description,
            link: this.form.link,
            image_url: this.form.picture
          }
        }

          var conStr = JSON.stringify(strJSON)
          var context = this
          var picture = this.selectedPicture
          var formData = new FormData()
          var dataReq = {
              action: this.form.link,
              content: conStr.replace(/'/g, "\\'"),
              is_active: true,
              section_id: parseInt(this.form.section_id),
              status: this.form.status
            }

        if(!this.$route.query.id) {
            formData.append('req', JSON.stringify(dataReq))
            formData.append('file', picture)

            ContentService.createContentDetail(formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/article' })
              else alert('Gagal simpan data')
              console.log(result)
            })
        } else {
            formData.append('req', JSON.stringify(dataReq))
            if(picture !== null) formData.append('file', picture)

            ContentService.updateContentDetail(this.$route.query.id, formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/article' })
              else alert('Gagal ubah data')
            })
        }
      }
    },
    handleChangePicture: function (event) {
			this.selectedPicture = event.blob
			this.form.picture = event.url
      console.log(event)
		},
    validateForm: function() {
      this.errors = []
      if(!this.form.name) this.errors.push('Judul wajib diisi')
      if(!this.form.link) this.errors.push('Link wajib diisi')
      if(!this.form.picture) this.errors.push('Gambar wajib diisi')
      if(!this.form.status) this.errors.push('Status wajib diisi')
      if(!this.form.description) this.errors.push('Deskripsi wajib diisi')
      if(!this.form.section_id) this.errors.push('Pilih section wajib diisi')
      if(!this.is_url_valid) this.errors.push('URL Web tidak valid')

      if(this.errors.length == 0) return true

      return false
    },
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?610088f0